.mc{color:var(--gray-900);}